import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/about'
export default {
  namespaced: true,
  state: {
    dataItem: {
      id: null,
      title: null,
      content: null,
      subtitle: null,
      text1: null,
      text2: null,
      mission: null,
      vision: null,
      image: null,
      items: [],
      projects_number: null,
      year: null,
    },

    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_VIDEO_EMBED_SAVE(state, data) {
      state.dataSaveEmbed = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
  },
  actions: {
    getDataItem({ commit }) {
      axiosIns
        .post(ROOT_URL)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
        })
        .catch(error => console.error(error))
    },
    getEmbedCode({ commit }, video_url) {
      return axiosIns
          .post(`${ROOT_URL}/embedCode`, { video_url })
          .then(response => {
            commit('SET_VIDEO_EMBED_SAVE', response.data)
            return response.data
          })
          .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      axiosIns
        .post(`${ROOT_URL}/saveData`, postData)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
